import { render, staticRenderFns } from "./ProjectHeader.vue?vue&type=template&id=08912cda&scoped=true&"
import script from "./ProjectHeader.vue?vue&type=script&lang=js&"
export * from "./ProjectHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08912cda",
  null
  
)

export default component.exports